import { createContext, useContext } from 'react';
export const MetricsContext = createContext({});
export const useMetricsContext = () => useContext(MetricsContext);
